export enum DelegationStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  REVOKED = 'revoked',
}

export interface VotingDelegation {
  id: string;
  assemblyId: string;
  delegatorId: string;
  delegateId: string;
  delegatedCoefficient: number;
  status: DelegationStatus;
  createdAt: string;
  acceptedAt?: string;
  revokedAt?: string;
  rejectedAt?: string;
  
  // Relaciones
  assembly?: {
    id: string;
    title: string;
    scheduledDate: string;
    startTime: string;
  };
  delegator?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    profile?: {
      apartment?: string;
    };
  };
  delegate?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
}

export interface DelegationSummary {
  totalDelegationsGiven: number;
  totalDelegationsReceived: number;
  totalVotingWeight: number;
  ownCoefficient: number;
  delegationsGiven: VotingDelegation[];
  delegationsReceived: VotingDelegation[];
}

export interface CreateDelegationDto {
  assemblyId: string;
  delegatorToken: string;
  delegateEmail: string;
  userId: string;
}

export interface VotingWeightInfo {
  totalWeight: number;
  canVote: boolean;
}

export interface ManagedAssemblyDelegationsSummary {
  totalCoefficientAccepted: number;
  totalCoefficientPending: number;
  totalCoefficientRevoked: number;
  totalCoefficientRejected: number;
  activePowersCount: number;
  uniqueDelegatorsAccepted: number;
  uniqueDelegatesAccepted: number;
  complexTotalCoefficient: number;
  delegationCoveragePercent: number;
}

export interface DelegationOperatorAssembliesResponse {
  complexes: Array<{ id: string; name: string }>;
  assemblies: Array<{
    id: string;
    title: string;
    scheduledDate?: string;
    startTime?: string;
  }>;
  complexId: string | null;
  complexName: string | null;
}

export interface ManagedAssemblyDelegationsResponse {
  delegations: VotingDelegation[];
  summary: ManagedAssemblyDelegationsSummary;
}
